export const formatMoney = function (a, n, x, s, c) {
  let re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")";
  let num = a.toFixed(Math.max(0, ~~n));

  return (c ? num.replace(".", c) : num).replace(
    new RegExp(re, "g"),
    "$&" + (s || ",")
  );
};

// Transforma valor de float para String formatada em dinheiro
export const convertFloatToMoney = (valor) => {
  return formatMoney(valor, 2, 3, ".", ",");
};

// Divide o Inteiro por 100 e converte em String formatada em dinheiro
// (Útil para exibir valores no Carrinho, Apostas, Extrato, Saques e etc.)
export const convertIntegerToMoney = (valor) => {
  return formatMoney(valor / 100, 2, 3, ".", ",");
};

// Divide o Inteiro por 100 e converte para Float com 2 casas decimais
// (Útil para exibir as Números)
export const convertIntegerToFloat = (valor) => {
  return (valor / 100).toFixed(2);
};

// Detecta se dispositivo é mobile ou desktop
// (Útil na renderização dos iframes)
export const getDeviceType = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return "mobile";
  }

  return "desktop";
};

export const getOrientation = () => {
  if (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i)
  ) {
    if (window.orientation === 90 || window.orientation === -90) {
      return "landscape";
    } else {
      return "portrait";
    }
  }

  // Em caso de não haver orientação(desktop) retorna landscape como default
  if (!screen.orientation) {
    return "landscape";
  }

  return screen.orientation.type == "landscape-primary"
    ? "landscape"
    : "portrait";
};

// Retorna o primeiro dia do mês corrente
export const getFirstDayOfMonth = () => {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  return new Date(y, m, 1);
};

// Retorna o último dia do mês corrente
export const getLasrDayOfMonth = () => {
  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  return new Date(y, m + 1, 0);
};

/**
 * converte date para string com timezone
 * @param {*} strDate
 * @returns
 */
export const convertDate = (strDate) => {
  let date = new Date(strDate);
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  return date.toLocaleDateString();
};



// WEBPACK FOOTER //
// ./src/modules/helpers.js